import { createMuiTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

const breakpoints = createBreakpoints({})

const gold1 = "#D3BC73";
const gold2 = "#EEE191";
const white = "#fff";
const black = "#101010"; //0a0a0a
const gray = "#888";

const bg1 = "#fff";
const bg2 = "#f7f7f7";

export default createMuiTheme({
  palette: {
    common: {
      white: `${white}`,
      black: `${black}`,
      gray: `${gray}`
    },
    primary: {
      main: `${gold1}`
    },
    secondary: {
      main: `${gold2}`
    },
    background: {
      bg1: `${bg1}`,
      bg2: `${bg2}`
    },
  },
  typography: {
    h1: {
      fontFamily: "Oswald, sans-serif",
      fontSize: "34px",
      letterSpacing: "3px",
      fontWeight: 500,
      lineHeight: 1.5,
      color: black,
    },
    h2: {
      fontFamily: "Oswald, sans-serif",
      fontSize: "18px",
      letterSpacing: "5px",
      fontWeight: 400,
      lineHeight: 1.5,
      color: gray,
    },
    h3: {
      fontFamily: "Rambla, sans-serif",
      fontSize: "22px",
      fontWeight: 700,
      lineHeight: 1.5,
      color: black,
    },
    subtitle1: {
      fontFamily: "Rambla, sans-serif",
      fontSize: "20px",
      fontWeight: "bold",
      lineHeight: 1.75,
      color: black,
    },
    subtitle2: {
      fontFamily: "Rambla, sans-serif",
      fontSize: "20px",
      fontWeight: 400,
      lineHeight: 1.75,
      color: gray,
      [breakpoints.down("xs")]: {
        fontSize: "16px",
      },
    },
    body1: {
      fontFamily: "Rambla, sans-serif",
      fontSize: "20px",
      fontWeight: "300",
      lineHeight: 1.75,
      color: black,
    },
    body2: {
      fontFamily: "Rambla",
      fontSize: "2.5rem",
      fontWeight: 700,
      lineHeight: 1.5,
      color: black,
    },
  },
  overrides: {

  }
})